export default "__VITE_ASSET__CzyLLuPI__"